// extracted by mini-css-extract-plugin
export default {"root":"TopBar_root__2EGf5","left":"TopBar_left__4NLz6","goBackButton":"TopBar_goBackButton__4P7kY"};